import CookieService from './cookie-service';

class ConsentService {
    private currentConsentLevel: number = 0;

    public validate(requiredConsentLevel: number): boolean {
        this.getCurrentConsentLevel();
        if (this.currentConsentLevel & requiredConsentLevel) {
            return true;
        }
        return false;
    }

    private getCurrentConsentLevel() {
        this.currentConsentLevel = +CookieService.getCookie('cookie_consent_level');
    }
}

export default new ConsentService();